import React, { useEffect, useState } from 'react';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { TelegramProvider } from './TelegramProvider';
import { TelegramTonProvider } from './TelegramTonProvider';
import { LilapeInterface } from './LilapeInterface';
import './telegram.css';

const MANIFEST_URL = 'https://lilape-ton-miniapp.netlify.app/tonconnect-manifest.json';

const TelegramApp = () => {
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        // Проверяем что Telegram WebApp доступен
        if (window.Telegram?.WebApp) {
            const tg = window.Telegram.WebApp;
            
            // Инициализация Telegram WebApp
            tg.ready();
            tg.expand();
            tg.enableClosingConfirmation();
            
            // Настройка темы под Telegram
            tg.setHeaderColor('#1a1a1a');
            tg.setBackgroundColor('#000000');
            
            // Отключаем вертикальные свайпы
            tg.disableVerticalSwipes();
            
            setIsReady(true);
        } else {
            // Fallback для разработки без Telegram
            console.warn('Telegram WebApp не найден, используем fallback режим');
            setIsReady(true);
        }
    }, []);

    if (!isReady) {
        return (
            <div className="telegram-loading">
                <div className="loading-spinner"></div>
                <p>Загрузка LILAPE...</p>
            </div>
        );
    }

    return (
        <TonConnectUIProvider manifestUrl={MANIFEST_URL}>
            <TelegramProvider>
                <TelegramTonProvider>
                    <div className="telegram-app">
                        <LilapeInterface />
                    </div>
                </TelegramTonProvider>
            </TelegramProvider>
        </TonConnectUIProvider>
    );
};

export default TelegramApp;
